import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

export const PageWrapper = styled.div`
  max-width: 1024px;
  width: 100%;

  @media only screen and (max-width: 1024px) {
    padding: 0 20px;
  }

  @media only screen and (max-width: 768px) {
    max-width: 480px;
  }
`

export const CreateWrapper = styled.div`
  width: 100%;
`

export const Title = styled.div`
  width: 100%;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
`

export const TopDescription = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`

export const ContentItemLink = styled(NavLink)`
  width: 300px;
  text-align: center;
  padding: 1rem;
  border: solid 1px ${({ theme }) => theme.text1};
  margin-right: 1rem;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text1};
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: bold;
  user-select: none;

  @media only screen and (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  :hover {
    border: solid 1px ${({ theme }) => theme.yetiBlue};
    color: ${({ theme }) => theme.yetiBlue};

    svg {
      fill: ${({ theme }) => theme.yetiBlue};
    }
  }

  &:last-child {
    margin-right: 0;
  }

  svg {
    width: 75%;
    height: 75%;
    margin: 1rem 0;

    fill: ${({ theme }) => theme.text1};
  }
`

export const ContentItem = styled.div`
  width: 300px;
  text-align: center;
  padding: 1rem;
  border: solid 1px ${({ theme }) => theme.text1};
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: bold;
  opacity: 0.5;
  user-select: none;
  position: relative;
  overflow: hidden;

  &:last-child {
    margin-right: 0;
  }

  svg {
    width: 75%;
    height: 75%;
    margin: 1rem 0;

    fill: ${({ theme }) => theme.text1};
  }

  .coming-soon {
    position: absolute;
    left: -50px;
    top: 30px;
    transform: rotate(-45deg);
    padding: 0.5rem;
    color: ${({ theme }) => theme.text3};
    background-color: ${({ theme }) => theme.text1};
    width: 200px;
    text-align: center;
  }
`

export const BottomDescription = styled.div`
  width: 100%;
`
